export const trackCtaClick = ({ cta, location, url }) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'cta_click', {
    cta,
    location,
    link_url: url
  });
};
